export default __webpack_public_path__ + "images/TI.a54b468.png";